import React from 'react'
import type { LucideIcon } from 'lucide-react'

export interface EmptyMetricCardProps {
  title: string
  icon: LucideIcon
  message?: string
}

export function EmptyMetricCard({
  title,
  icon: Icon,
  message = 'Dados não disponíveis'
}: EmptyMetricCardProps) {
  return (
    <div className="metric-card group opacity-60">
      <div className="flex items-center justify-between mb-4">
        <div className="p-2 rounded-monumenta bg-brand-dark-lighter transition-colors duration-200">
          <Icon className="text-brand-gray" size={24} />
        </div>
      </div>
      <div className="text-center py-2">
        <div className="text-3xl sm:text-4xl font-display font-bold text-brand-gray/50 mb-1">
          —
        </div>
        <p className="text-xs text-brand-gray">
          {message}
        </p>
      </div>
      <div className="metric-label">
        {title}
      </div>
    </div>
  )
}
